import { connect } from 'react-redux';

import { selectToken } from './Auth.selectors';
import { userResetPassword as userResetPasswordAction } from './Auth.saga';
import ResetPassword from './ResetPassword';

function mapStateToProps(state) {
  return {
    resetToken: selectToken(state),
  };
}

const mapDispatchToProps = {
  userResetPassword: userResetPasswordAction,
};

function mergeProps(stateProps, dispatchProps) {
  const { resetToken } = stateProps;
  const { userResetPassword } = dispatchProps;
  return {
    handleSubmit: (formValues, formAsyncFns) => userResetPassword({ ...formValues, resetToken }, formAsyncFns),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ResetPassword);
